module.exports = __webpack_public_path__ + "static/apple_store_badge-48a093d8723ef5fd50e66bb596fb3943.svg";